import * as React from 'react';
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
  withRouter,
} from 'react-router-dom';

import Identity from './components/identity';

import i18n, { DEFAULT_LANG } from './lib/i18n';
import Main from './components/main';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { State } from './store/index';

class ContentRoutes extends React.Component {
  static validateCurrentLanguage(props) {
    let lang = props.match.params.lang;
    const languages = props.config.languages.map((item) => item.posixCode);
    if (languages.indexOf(lang) === -1) {
      lang = DEFAULT_LANG;
      props.match.params.lang = lang;
    }
    ContentRoutes.updateLanguage(lang);
    return props;
  }

  componentDidMount() {
    ContentRoutes.validateCurrentLanguage(this.props);
  }

  componentDidUpdate(nextProps) {
    ContentRoutes.validateCurrentLanguage(nextProps);
  }

  static updateLanguage(lang: string) {
    i18n.setLanguage(lang);
  }

  render() {
    return <Identity />;
  }
}

const ConnectedContentRoutes = compose(
  withRouter,
  connect(({ config }: State) => ({ config }))
)(ContentRoutes);

const LanguageRoutes: React.FunctionComponent = () => (
  <Router>
    <Switch>
      <Route
        path='/:lang'
        render={() => (
          <Main>
            <ConnectedContentRoutes />
          </Main>
        )}
      />
      <Redirect to={DEFAULT_LANG} />
    </Switch>
  </Router>
);

export default LanguageRoutes;



// WEBPACK FOOTER //
// ./node_modules/eslint-loader!./src/routes.tsx